<template>

    <v-form v-model="formValid">

        <v-row row justify-space-between>
            <v-col cols="6">
                <password-field
                        v-model="passwordValue"
                        label="New password"
                        label-confirm="Confirm password"
                        :error-messages="errorMessages"
                />
                <v-col cols="12" class="mt-3 text-sm-left">
                    <v-btn color="primary" :disabled="!formValid || passwordUpdating" @click="submit()">Update
                    </v-btn>
                </v-col>
            </v-col>
        </v-row>

    </v-form>
</template>

<script>

    import PasswordField from '../../../components/UI/PasswordField';

    export default {

        props: ['errorMessages', 'passwordUpdating'],

        components: {
            'password-field': PasswordField,
        },

        data() {
            return {
                formValid: false,
                passwordValue: '',
            }
        },

        methods: {
            submit() {
                this.$emit('password-updated', this.passwordValue);
            }
        }
    }
</script>
